import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';

const CourierSlots = {
  formatDatePicker() {
    $(`#courier_slot_start`).datepicker({
      dateFormat: `yy-mm-ddT00:00`,
    });
  },

  showCarrierServiceOption() {
    const id = $(`#carrier`).val();
    if (id) {
      $(`#carrier_${id}`).show();
    }
  },

  bindChange() {
    $(`#carrier`).change((e) => {
      $(`.carrier_service_option input:checkbox`).prop(`checked`, false);
      $(`.carrier_service_option`).hide();

      const id = e.target.value;
      $(`#carrier_${id}`).show();
      $(`#carrier_${id}`).removeClass(`hide`);

      const $checkbox = $(`#carrier_${id} input:checkbox`);
      if ($checkbox.length === 1) {
        $checkbox.prop(`checked`, true);
      }
    });
  },

  bindToPage() {
    this.formatDatePicker();
    this.showCarrierServiceOption();
    this.bindChange();
  },

  init() {
    if ($(`#courier_slot_start`).length === 0) {
      return;
    }
    this.bindToPage();
  },
};

export default CourierSlots;
